export default {
  delivered: {
    'link-feedback-popup': {
      title: 'Obrigado por utilizar o nosso serviço. A sua opinião é importante para nós.',
      subtitle: 'Deixe uma avaliação na nossa página do Google',
      btn: 'Ok',
    },
    info: {
      'payment-delivered-title': 'Entregue',
    },
    feedback: {
      title: 'A sua opinião é importante para nós',
      comment: {
        title: 'Deixe os seus comentários:',
        placeholder: 'Diga-nos se gostou de tudo, quais eram as suas expectativas e impressões',
        'send-btn': 'Enviar comentário',
        'change-btn': 'Alterar comentário',
        'not-send-tooltip': {
          text: 'Contactem-me',
          title: 'O apoio ao cliente irá ligar-lhe',
          content: 'Deixe o seu comentário e um agente do nosso apoio ao cliente entrará em contacto consigo em breve.',
        },
      },
      suggestions: {
        driver: {
          positive: {
            'went-above-and-beyond': 'Superou as expectativas',
            'professional-appearance': 'Aparência profissional',
            'courteous-and-respectful': 'Cortês e respeitoso',
            'on-time-delivery': 'Entrega pontual',
          },
          negative: {
            'unfriendly-driver': 'Estafeta pouco simpático',
            'did-not-follow-instructions': 'Não seguiu as instruções',
            'late-delivery': 'Entrega atrasada',
            'unprofessional-appearance': 'Aparência pouco profissional',
          },
        },
        dispatcher: {
          positive: {
            'great-communication': 'Excelente comunicação',
            'patient-and-understanding': 'Paciente e compreensivo',
            'efficient-coordination': 'Coordenação eficiente',
            'quick-response-time': 'Resposta rápida',
          },
          negative: {
            'impatient-or-rude': 'Impaciente ou rude',
            'poor-coordination': 'Má coordenação',
            'failed-to-address-concerns': 'Não resolveu as questões',
            'slow-response-time': 'Resposta lenta',
          },
        },
        pharmacy: {
          positive: {
            'friendly-staff': 'Equipa simpática',
            'secure-packaging': 'Embalagem segura',
            'fast-shipping': 'Envio/renovações rápidos',
            'concise-medication-instructions': 'Instruções do medicamento claras',
          },
          negative: {
            'difficult-to-open': 'Difícil de abrir',
            'incorrect-prescription': 'Receita incorreta',
            'unfriendly-staff': 'Equipa pouco simpática',
            'wrong-medication': 'Medicamento errado',
          },
        },
      },
    },
  },
  delivering: {
    confirmed: {
      'stops-away': 'paragens de distância',
      'your-stop-is-next': 'A sua paragem é a próxima',
      'special-instruction': {
        title: 'Instruções especiais da farmácia:',
        'new-instruction-input': {
          title: 'Instruções especiais do destinatário',
          placeholder: 'Adicionar instrução especial',
        },
        'new-instruction-btn-save': 'Guardar',
        'not-editable-warning': 'Lamentamos, não é possível alterar as instruções especiais porque o estafeta já está perto.',
      },
      'arriving-data': {
        today: {
          'label-2': 'Chega hoje',
          label: 'Hora prevista de entrega',
        },
        next: {
          label: 'O estafeta chegará em',
          time: 'Poucos minutos',
        },
        'few-minutes': {
          'label-2': 'O estafeta chegará em',
        },
      },
      qr: {
        info: 'Mostre o código QR ao estafeta',
        description: 'Para receber a sua encomenda, mostre o código QR ao estafeta ou diga o código',
        help: 'O copagamento é um valor fixo em dólares que tem de pagar por serviços de saúde ou medicamentos cobertos, conforme definido pelo seu plano de seguro.',
      },
    },
    'confirmed-no-route': {
      title: 'Confirmou a entrega',
      subtitle: 'Aguarde mais informações',
      'for-date': 'para {date}',
    },
    'not-confirmed': {
      form: {
        'empty-title': 'Não se esqueça de assinar',
        'pharmacy-instruction-title': 'Instruções especiais da farmácia:',
        'recipient-instruction': {
          title: 'Instruções especiais do destinatário:',
          placeholder: 'Adicionar instrução especial',
          'update-btn': 'Atualizar',
        },
        sign: {
          description: 'O estafeta tentará a entrega presencial. Se não estiver ninguém em casa, deixará a encomenda junto à porta e tirará uma fotografia.',
          confirm: {
            btn: 'Confirmar entrega',
            title: 'Tem a certeza?',
            text: 'Confirmo que as informações que forneci são corretas e exatas',
          },
        },
      },
      progress: {
        attempts: 'Tentativa de entrega:',
        created: 'Encomenda <br> criada',
      },
      transit: 'Em trânsito',
      'out-for-delivery': 'Saiu para <br> entrega',
      delivered: 'Entregue',
      signature: {
        title: 'Assine abaixo para autorizar a entrega sem assinatura presencial:',
        clear: 'Limpar',
      },
      statuses: {
        'at-pharmacy': 'A sua encomenda está na farmácia e será entregue',
        'driver-out': 'Confirme a sua entrega',
        rescheduled: 'Entrega reagendada para',
        'pending-back-to-pharmacy': 'A sua encomenda aguarda devolução à farmácia',
        'pickup-occured': 'A sua encomenda foi recolhida na farmácia e será entregue',
      },
    },
    rescheduled: {
      attempted: 'Tentativa em',
    },
  },
  investigation: {
    link_start: 'Contacte-nos através de',
    link_end: 'para agendar uma entrega',
    instructions: 'Instruções especiais da farmácia:',
  },
  rescadule: {
    subtitle: 'Selecione uma nova data de entrega',
    'too-many': 'A encomenda não pode ser reagendada mais de 3 vezes. Ligue para {phone}',
    'wrong-address': 'O estafeta não conseguiu localizar a sua morada. Indique a morada correta.',
    'not-present': 'O estafeta esteve na sua morada, mas ninguém atendeu.',
  },
  rejected: {
    'back-to-pharmacy': {
      rejected: 'A encomenda foi cancelada pela farmácia',
      'pending-back-to-pharmacy': 'A sua encomenda foi cancelada e aguarda devolução à farmácia',
      'on-its-way-to-pharmacy': 'A sua encomenda foi cancelada e a devolução à farmácia foi confirmada',
      default: 'A sua encomenda foi cancelada e devolvida à farmácia',
      'confirmed-back-to-pharmacy': 'A sua encomenda foi cancelada; a aguardar confirmação de devolução pela farmácia',
      'back-to-pharmacy': 'A sua encomenda foi cancelada e devolvida à farmácia',
    },
  },
  returned: {
    'back-to-pharmacy': {
      title: 'A sua encomenda aguarda devolução à farmácia',
    },
  },
}
